var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("v-form-message", {
        attrs: {
          id: "form-success",
          message: _vm.objectSuccess,
          type: "success",
          isVisible: _vm.objectSuccess !== null,
          "auto-close-timeout": _vm.autoCloseTimeout,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "dialog", class: { active: _vm.isVisible } }, [
        _c("div", { staticClass: "dialog--content dialog--content-default" }, [
          _c("h2", [_vm._v(_vm._s(_vm.getPageTitle))]),
          _vm._v(" "),
          _c(
            "form",
            {
              attrs: { action: "", method: "POST", novalidation: "" },
              on: { submit: _vm.onSubmitObject },
            },
            [
              _vm.objectError !== null
                ? _c(
                    "div",
                    { staticClass: "form-message form-message--error" },
                    [_vm._v(_vm._s(_vm.objectError))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isUpdateMethod
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "form-control form-control--static form-control--file",
                      },
                      [_vm._v(_vm._s(_vm.object.file.name))]
                    ),
                  ])
                : _c(
                    "div",
                    {
                      staticClass: "form-group",
                      class: { "form-group--error": _vm.$v.object.file.$error },
                    },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.$v.object.file.$model.name,
                            expression: "$v.object.file.$model.name",
                          },
                        ],
                        staticClass: "form-control form-control--file",
                        attrs: {
                          type: "text",
                          name: "file",
                          role: "button",
                          "aria-label": _vm.$t("form.upload.file.plc"),
                          "aria-controls": "filename",
                          placeholder: _vm.$t("form.upload.file.plc"),
                          autocomplete: "false",
                          readonly: "",
                        },
                        domProps: { value: _vm.$v.object.file.$model.name },
                        on: {
                          click: _vm.choseFiles,
                          input: function ($event) {
                            if ($event.target.composing) return
                            _vm.$set(
                              _vm.$v.object.file.$model,
                              "name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("input", {
                        ref: "file",
                        staticClass: "form-control",
                        attrs: {
                          type: "file",
                          name: "file",
                          "aria-hidden": "true",
                          tabindex: "-1",
                          autocomplete: "false",
                        },
                        on: { change: _vm.onChangeFile },
                      }),
                    ]
                  ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c("textarea", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.commentIsVisible,
                      expression: "commentIsVisible",
                    },
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.object.comment,
                      expression: "object.comment",
                    },
                  ],
                  staticClass: "form-control form-control--textarea",
                  attrs: {
                    name: "comment",
                    placeholder: _vm.$t("form.upload.comment.plc"),
                  },
                  domProps: { value: _vm.object.comment },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.object, "comment", $event.target.value)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm.isUpdateMethod
                  ? _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: {
                          role: "button",
                          type: "submit",
                          title: _vm.$t("form.upload.update"),
                          disabled: _vm.objectFormDisabled,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("form.upload.update")) +
                            "\n                    "
                        ),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: {
                          role: "button",
                          type: "submit",
                          title: _vm.$t("form.upload.create"),
                          disabled: _vm.objectFormDisabled,
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.$t("form.upload.create")) +
                            "\n                    "
                        ),
                      ]
                    ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "close-button",
              on: {
                click: function ($event) {
                  return _vm.onClickAction("close")
                },
              },
            },
            [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }